import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Domain_LocalResourcesDefinition  {
    _originalTypeClassName = "ekylikeio.BO.Domain_LocalResourcesDefinition";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Domain_LocalResourcesDefinition.translate = translateService;
}
this.DTOs_Primary_School = null;
this.DTOs_Middle_School = null;
this.DTOs_High_School = null;
this.DTOs_RES_CUSTOM_ALL = null;
this.CoreBO_Res_ASSOC_MenuItemCategory_MenuItem_Category = null;
this.CoreBO_Res_ASSOC_SchoolClass_Student_SchoolClass = null;
this.CoreBO_Res_ASSOC_School_SchoolClass_Level = null;
this.CoreBO_Res_ASSOC_FileData_ProductTag_Image = null;
this.Res_ENUM_SchoolLevel_Primary = null;
this.Res_ENUM_SchoolLevel_Middle = null;
this.Res_ENUM_SchoolLevel_High = null;
this.OrderBO_Res_ASSOC_Payment_Order_orderToPayment = null;
this.OrderBO_Res_ASSOC_UserAcount_Order_CreatedBy = null;
this.OrderBO_Res_ASSOC_Student_OrderSection_Student = null;
this.Res_ENUM_OrderStatus_New = null;
this.Res_ENUM_OrderStatus_Completed = null;
this.Res_ENUM_OrderStatus_Submitted = null;
this.Res_ENUM_OrderStatus_InProgress = null;
this.Res_ENUM_OrderItemStatus_New = null;
this.Res_ENUM_OrderItemStatus_Ready = null;
this.OrderBO_RES_CUSTOM_ERROR_MIN_VALUE = null;
this.Res_ENUM_EmailStatus_Initialized = null;
this.Res_ENUM_EmailStatus_Queued = null;
this.Res_ENUM_EmailStatus_Sent = null;
this.Res_ENUM_EmailStatus_Failed = null;
this.NotificationBO_UtilitiesBO_RES_EMAIL_ALREADY_QUEUED = null;
this.NotificationBO_UtilitiesBO_RES_EMAIL_ALREADY_SENT = null;
}

static translate: TranslateService;
_key: any;
DTOs_Primary_School:any;
DTOs_Middle_School:any;
DTOs_High_School:any;
DTOs_RES_CUSTOM_ALL:any;
CoreBO_Res_ASSOC_MenuItemCategory_MenuItem_Category:any;
CoreBO_Res_ASSOC_SchoolClass_Student_SchoolClass:any;
CoreBO_Res_ASSOC_School_SchoolClass_Level:any;
CoreBO_Res_ASSOC_FileData_ProductTag_Image:any;
Res_ENUM_SchoolLevel_Primary:any;
Res_ENUM_SchoolLevel_Middle:any;
Res_ENUM_SchoolLevel_High:any;
OrderBO_Res_ASSOC_Payment_Order_orderToPayment:any;
OrderBO_Res_ASSOC_UserAcount_Order_CreatedBy:any;
OrderBO_Res_ASSOC_Student_OrderSection_Student:any;
Res_ENUM_OrderStatus_New:any;
Res_ENUM_OrderStatus_Completed:any;
Res_ENUM_OrderStatus_Submitted:any;
Res_ENUM_OrderStatus_InProgress:any;
Res_ENUM_OrderItemStatus_New:any;
Res_ENUM_OrderItemStatus_Ready:any;
OrderBO_RES_CUSTOM_ERROR_MIN_VALUE:any;
Res_ENUM_EmailStatus_Initialized:any;
Res_ENUM_EmailStatus_Queued:any;
Res_ENUM_EmailStatus_Sent:any;
Res_ENUM_EmailStatus_Failed:any;
NotificationBO_UtilitiesBO_RES_EMAIL_ALREADY_QUEUED:any;
NotificationBO_UtilitiesBO_RES_EMAIL_ALREADY_SENT:any;




}